import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const Guard = () => {
  const userProfile  = useSelector((state) => state.root.userProfile);
  const loadingAuth = useSelector((state) => state.root.loadingAuth);

  if (loadingAuth) {
    return <div>Loading...</div>;
  }

  if (!userProfile) {
    return <Navigate to="/auth/signin" replace />;
  }

  return <Outlet />;
};

export default Guard;
